// @ts-strict-ignore
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  text: {
    marginTop: `${theme.spacing(4)} !important`,
  },
  iconButton: {
    marginTop: `${theme.spacing(-2)} !important`,
    marginBottom: `${theme.spacing(-2)} !important`,
    marginLeft: `${theme.spacing(2)} !important`,
  },
  listItemText: {
    flexGrow: '0 !important',
  },
  editButton: {
    marginLeft: `${theme.spacing(2)} !important`,
  },
  primaryText: {
    display: 'inline-block',
    verticalAlign: 'middle',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    lineHeight: '1em',
  },
  icon: {
    minWidth: `${theme.spacing(8)} !important`,
    [theme.breakpoints.down('sm')]: {
      minWidth: '42px !important',
      marginLeft: `${theme.spacing(-3)} !important`,
    },
  },
  item: {
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0 !important',
    },
  },
  helpButton: {
    width: '24px !important',
    height: '24px !important',
    marginLeft: `${theme.spacing(1)} !important`,
  },
  countriesWrapper: {
    maxWidth: '400px',
    lineHeight: '1.5em',
    color: theme.palette.secondary[400],
  },
}))
